module.exports = __webpack_public_path__ + "img/lipigo_1.4c981f51.png";